// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fTCzy","maxWidthContainer":"styles_maxWidthContainer__A9fw8","background":"styles_background__CVoEq","logos":"styles_logos__1maqd"};